import React, { useEffect, useState } from "react";

import { IntlProvider } from "react-intl";

import { CwsModal } from "cms-web-styleguide/dist/components/CwsModal/CwsModal";

import { Banner } from "../Banner/Banner";
import { Popup } from "../Popup/Popup";

import { i18n } from "../../i18n/i18n";

import { modal } from "cms-web-styleguide/dist/utils/utils";

import { isFileExists, setCookies, setEvent } from "../../utils/utils";

import "./App.scss";

const App = (props) => {
  const { env, link, locale, tab } = props.config;

  const [currentLocale, setCurrentLocale] = useState(isFileExists(locale) ? locale : "en-xz");

  const [popupVisible, setPopupVisible] = useState(link ? link : false);

  const handleLocaleChange = (langCode) => {
    setCurrentLocale(langCode);
  };

  const openPopup = () => {
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
    modal.page.activate();
    window.CWC.destroy();
  };

  const saveCookies = (chosenCookies) => {
    setCookies(chosenCookies);
    setEvent("cms-web-consent-root-accept");
    closePopup();
  };

  useEffect(() => {
    const element = document.getElementById(tab);

    if (element) {
      element.click();
    }

    modal.addEventModalShow("cookie-consent-modal");

    return () => {
      modal.page.activate();
    };
  });

  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg">
        <defs>
          <symbol id="arrow-down" fill="none" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="m21 7.5-9 9-9-9"
              vectorEffect="non-scaling-stroke"
            />
          </symbol>
          <symbol id="arrow-up" fill="none" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="m21 16.5-9-9-9 9"
              vectorEffect="non-scaling-stroke"
            />
          </symbol>
          <symbol id="check" fill="none" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="m4 12.646 4.924 4.924L20.032 6.462"
              vectorEffect="non-scaling-stroke"
            />
          </symbol>
          <symbol id="cookie" fill="none" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M13.482 3.437h-2.964c-.845 0-1.669.268-2.352.764L5.768 5.944a4.002 4.002 0 0 0-1.454 2l-.916 2.82a4.002 4.002 0 0 0 0 2.473l.916 2.819c.261.803.77 1.504 1.454 2L8.166 19.8a4.002 4.002 0 0 0 2.352.764h2.964a4 4 0 0 0 2.352-.764l2.398-1.742a4.002 4.002 0 0 0 1.454-2.001l.916-2.82a4.002 4.002 0 0 0 0-2.473l-.916-2.819a4.002 4.002 0 0 0-1.454-2L15.834 4.2a4.002 4.002 0 0 0-2.352-.764Z"
              clipRule="evenodd"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M9.124 8.999a.125.125 0 1 1-.125-.125"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M8.999 8.874c.069 0 .125.056.125.125m5.002-1.001A.125.125 0 1 1 14 7.873"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M14 7.873c.07 0 .126.056.126.125M16.127 12a.125.125 0 1 1-.125-.125"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M16.002 11.875c.069 0 .125.056.125.125m-4.002 0a.125.125 0 1 1-.125-.125"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M12 11.875c.07 0 .125.056.125.125m-4.002 2a.125.125 0 1 1-.125-.124"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M7.998 13.876c.07 0 .125.056.125.125m5.003 2.001a.125.125 0 1 1-.126-.125"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M13 15.877c.07 0 .126.056.126.125"
              vectorEffect="non-scaling-stroke"
            />
          </symbol>
          <symbol id="global-menu" fill="none" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M12 21.004A9.004 9.004 0 1 1 21.004 12M3.51 8.999h16.98M3.51 15.001H12"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M16.002 12a15.484 15.484 0 0 0-2.168-7.943 2.115 2.115 0 0 0-3.667 0 15.635 15.635 0 0 0 0 15.887 2.126 2.126 0 0 0 1.834 1.06"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M17.416 14.001a4.002 4.002 0 1 1 0 8.003 4.002 4.002 0 0 1 0-8.003"
              vectorEffect="non-scaling-stroke"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M18.503 17.959a.044.044 0 0 0 0 .088h0a.044.044 0 0 0 .038-.066.044.044 0 0 0-.038-.022h0m-2.174 0a.044.044 0 0 0-.044.044v0c0 .024.019.045.044.046.025 0 .045-.02.046-.044a.045.045 0 0 0-.044-.046h-.001"
              vectorEffect="non-scaling-stroke"
            />
          </symbol>
        </defs>
      </svg>

      <IntlProvider locale={currentLocale} messages={i18n(currentLocale)}>
        <CwsModal className="cwc-modal" disableClickOutside hideCloseButton id="cookie-consent-modal">
          {popupVisible ? (
            <Popup
              env={env}
              handleLocaleChange={handleLocaleChange}
              onSaveCookies={saveCookies}
              locale={currentLocale}
            />
          ) : (
            <Banner
              env={env}
              handleLocaleChange={handleLocaleChange}
              locale={currentLocale}
              onOpenPopup={openPopup}
              onSaveCookies={saveCookies}
            />
          )}
        </CwsModal>
      </IntlProvider>
    </>
  );
};

export { App };
